export const AlignType = {
    HORIZONTAL_LEFT: 'horizontal_left',
    HORIZONTAL_CENTER: 'horizontal_center',
    HORIZONTAL_RIGHT: 'horizontal_right',
    HORIZONTAL_JUSTIFY: 'horizontal_justify',
    HORIZONTAL_DISTRIBUTE: 'horizontal_distribute',
    VERTICAL_TOP: 'vertical_top',
    VERTICAL_CENTER: 'vertical_center',
    VERTICAL_BOTTOM: 'vertical_bottom',
};

export const IndentType = {
    INDENT_INCREASE: 'indent_increase',
    INDENT_REDUCE: 'indent_reduce',
};
